// AI Generated Test
import { Injectable } from '@angular/core';
import { safeClone } from '@client/app/shared/utils/object-utils';
import { GlobalHelperService } from '@client/app/services/global-helper/global-helper.service';

@Injectable({
    providedIn: 'root',
})
export class AccessibilityDialogsNewHelpCenterDecisionTreeService {
    private decisionTree: any = {
        check_ids: [],
        questions: [],
        results: [],
    };

    constructor (private globalHelperService: GlobalHelperService) {}

    /**
     * Replace the questions stack with questions provided from argument
     * @param questions - Questions Collection to use in the Decision Tree
     */
    setQuestions (questions: any[]): void {
        this.decisionTree.questions = questions;
        this.decisionTree.results = [];
    }

    /**
     * Add question to the Result stack, will also contain the answer property the User selected
     * @param question - Question Object
     * @param answerText - Text of the answer
     * @param answer - Selected Answer from the User.
     */
    addResult (question: any, answer: string | object, answerText: string): void {
        const result: any = safeClone(question);
        result.answer = answer;
        result.answerText = answerText;
        this.decisionTree.results.push(result);
    }

    /**
     * Get entire Results stack from the Decision Tree
     */
    getAllResults (): any[] {
        return this.decisionTree.results;
    }

    /**
     * Return the Latest Result item from the Result Stack
     */
    getLatestResult (): any {
        return this.decisionTree.results.at(-1);
    }

    /**
     * Remove all Result items from specified result to end of result stack
     * @param result - Result Object
     */
    resetToResult (result: any): void {
        const stringifiedResultItem = this.globalHelperService.stringify(result);
        const index = this.decisionTree.results.findIndex((resultItem) => {
            return this.globalHelperService.stringify(resultItem) === stringifiedResultItem;
        });

        if (index > -1) {
            this.decisionTree.results.splice(index, this.decisionTree.results.length - index);
        }
    }

    /**
     * Return the Question that should be answered in the Decision Tree
     */
    getActiveQuestion (): any {
        const result = this.getLatestResult();
        if (typeof result === 'undefined') {
            return this.decisionTree.questions[0];
        }

        if (typeof result.answer !== 'string') {
            return null;
        }

        return this.decisionTree.questions.find((question: any) => question.id === result.answer) || null;
    }
}
